import {useSanitizeString} from 'core/hooks/useSanitizeString';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {Typography} from 'components/Typography';
import {BrandLogo} from 'modules/product-card/components/BrandLogo';
import {selectProductData} from 'modules/product-card/selectors';
import {FC} from 'react';
import style from './style.module.scss';

export const BrandInfo: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {brand} = productData || {};

    const description = useSanitizeString(brand?.description);

    return (
        <div className={style.main}>
            <Typography variant={'title-18-m'}>О бренде</Typography>
            <div className={style.logo}>
                <BrandLogo />
            </div>
            <Typography className={style.description} variant={'body-16-r'}>
                {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                <span dangerouslySetInnerHTML={{__html: description}} />
            </Typography>
        </div>
    );
};
